import React from 'react'
import clsx from 'clsx'
import { CircularProgress } from '@mui/material'

import useStyles from './styles'

interface LoadingSpinnerProps {
  className?: string
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ className }) => {
  const classes = useStyles()

  return <CircularProgress className={clsx(classes.root, className)} />
}

export default LoadingSpinner
